import { createTheme, MantineColorsTuple } from "@mantine/core";

const orange: MantineColorsTuple = [
  "#fff4e6",
  "#ffe8cc",
  "#ffd8a8",
  "#ffc078",
  "#ffa94d",
  "#ff922b",
  "#ff8d3a",
  "#e8590c",
  "#d9480f",
  "#c92a2a",
];

export const theme = createTheme({
  primaryColor: "orange",
  colors: {
    orange,
  },
  fontFamily: "'Space Grotesk', sans-serif",
  headings: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontWeight: "400",
  },
  fontSizes: {
    xs: "11px",
    sm: "13px",
    md: "15px",
    lg: "17px",
    xl: "20px",
  },
  defaultRadius: "md",
  cursorType: "pointer",
  components: {
    Button: {
      defaultProps: {
        radius: "md",
      },
      styles: {
        root: {
          letterSpacing: "0.02em",
          fontWeight: 600,
          transition: "all 0.15s ease",
        },
      },
    },
    Paper: {
      styles: {
        root: {
          borderColor: "rgba(0, 0, 0, 0.08)",
        },
      },
    },
    TextInput: {
      styles: {
        input: {
          backgroundColor: "#f1f3f5",
          borderColor: "rgba(0, 0, 0, 0.10)",
          color: "#212529",
          transition: "border-color 0.15s ease",
        },
        label: {
          color: "#495057",
          fontWeight: 500,
          marginBottom: 4,
        },
      },
    },
    ActionIcon: {
      styles: {
        root: {
          transition: "all 0.15s ease",
        },
      },
    },
  },
});
